import { getAPIUrl } from '../global';
import { Get, Post, Put, Remove } from '../headerIntercepter';

export const createTest = (data,params) => {
  const url = getAPIUrl('organization.test.create',params);
  return Post(url, data, true);
};
export const getTests=(params)=>{
  const url=getAPIUrl('organization.test.self',params);
  return Get(url,true,{});
}

export const updateTestbyid=(data,params)=>{
  const url=getAPIUrl('organization.test.update',params);
  return Put(url,data,true);
}